"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShoppingCartSchema = exports.CartItemSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.CartItemSchema = zod_1.z.object({
    id: __1.ShortStringSchema.uuid(),
    variantId: __1.ShortStringSchema.uuid(),
    title: zod_1.z.string(),
    pictures: __1.PicturesSchema,
    quantity: zod_1.z.number(),
    status: zod_1.z.nativeEnum(__1.OfferStatus).optional(),
    archived: zod_1.z.boolean().optional(),
    price: __1.MoneySchema.optional(),
    optionMapping: zod_1.z.array(__1.ItemVariantOptionMapSchema).max(__1.MAX_ITEM_OPTION_VALUES).optional(),
    changes: zod_1.z
        .object({
        quantity: zod_1.z
            .object({
            itemQuantity: zod_1.z.number().optional(),
            itemStoreQuantity: zod_1.z.number().optional(),
            type: zod_1.z.nativeEnum(__1.ShoppingCartItemQuantityType).optional(),
        })
            .optional(),
        price: zod_1.z
            .object({
            oldPrice: __1.MoneySchema.optional(),
            newPrice: __1.MoneySchema.optional(),
            type: zod_1.z.nativeEnum(__1.ShoppingCartItemPriceType).optional(),
        })
            .optional(),
    })
        .optional(),
});
exports.ShoppingCartSchema = zod_1.z.object({
    items: exports.CartItemSchema.array(),
    promotion: __1.PromotionSchema.pick({ code: true }).optional(),
    updatedAt: __1.ShortStringSchema.nullable(),
});
//# sourceMappingURL=shopping-cart.js.map